/* Component Dependencies */
var highlightedHotelsTemplate = require('templates/highlightedHotels.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var validator = require('validator');
require('libs/jquery.dotdotdot');

AriesComponent.create({
  type: 'highlightedHotels',
  template: {
    'highlightedHotels': highlightedHotelsTemplate
  },
  bindEvents: function() {
    this.$el.find('.js-hotel-record-item').each(function(index, element){
      // applying multiline elipsis
      var $element = $(element);
      $element.find('.l-hotel-name').dotdotdot();
    });
  }
});
